import * as firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/firestore';

export class FireBaseService {
    public static firestore;
    public static analitics;

    public static initApp(): void {
        firebase.initializeApp({
            apiKey: "AIzaSyABa7vqWh4fC0Wrf2bcm3gGsjzWk3xUxzQ",
            authDomain: "maybellinematch3game.firebaseapp.com",
            databaseURL: "https://maybellinematch3game.firebaseio.com",
            projectId: "maybellinematch3game",
            storageBucket: "maybellinematch3game.appspot.com",
            messagingSenderId: "584954297975",
            appId: "1:584954297975:web:e9cbd9d264311309779072",
            measurementId: "G-SXDLR1FG33"
        })

        // this.firestore = firebase.firestore();
        this.analitics = firebase.analytics();
    }

    public static getUserLeaderbord() {
        return FireBaseService.firestore.collection('users').limitToLast(10).orderBy("score").get();
    }

    public static getCurrentUser(id): void {
        return FireBaseService.firestore.collection('users').where('mblnId', '==', id).get();
    }

    public static createUser(name: string) {
        return FireBaseService.firestore.collection('users').add({ user: name, score: 0 })
    }
}